









import { Component, Vue } from "vue-property-decorator";

@Component<Progress>({
  props: {
    size: {
      type: Number,
      default: 48
    },
    color: {
      type: String,
      default: "white"
    }
  }
})
export default class Progress extends Vue {
  private get s() {
    return this.$props.size;
  }
  private get c() {
    return this.$props.color;
  }

  private get style() {
    return "border-color: " + this.c + " transparent transparent transparent";
  }

  //   private get rollerStyle() {
  //     return "width: " + this.s + "px; height: " + this.s + "px;";
  //   }

  //   private dotStyle(index: number) {
  //     const halfSize = this.s * 0.5;
  //     const x =
  //     return "transform-origin: " + halfSize + "px " + halfSize + "px;";
  //   }
}
